import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PLAN_Z_FREE_GIFT_I18N_NAMESPACE =
  '@mc/promos/experiments/prcng-955_v1_plan_z_free_gift'

export const i18nInstance = registerI18nResources({
  namespace: PLAN_Z_FREE_GIFT_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
